import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { IApiGetListStoresParam, IDetailStore, IStore, ITimezone } from '../interfaces/api';
import { PaginationResponse } from 'services/commonTypes';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { IPlaylist } from 'modules/playlist/interfaces/api';
/**
 * please change reducer name
 */
// @ts-ignore
type MyState = RootState['store']; // ex: RootState['booking']
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['store']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('demoData') as IDEMOModelResDataItem[];
const getDataStores = () => selector('dataStores') as PaginationResponse<IStore>;
const getStoreListParams = () => selector('storeListParams') as IApiGetListStoresParam;
const getScreenListInStore = () => selector('screenListInStore') as PaginationResponse<IScreen>;
const getParamsScreensInStore = () => selector('screensListInStoreParams') as IApiGetListStoresParam;
const getTimezones = () => selector('timezones') as ITimezone[];
const getAllStores = () => selector('allStores') as PaginationResponse<IStore>;
const getDetailStore = () => selector('detailStore') as IDetailStore;
const getPlaylistListInStore = () => selector('playlistListInStore') as PaginationResponse<IPlaylist>;

const storeSelectors = {
  getDemoData,
  getDataStores,
  getStoreListParams,
  getScreenListInStore,
  getParamsScreensInStore,
  getTimezones,
  getAllStores,
  getDetailStore,
  getPlaylistListInStore,
};
export default storeSelectors;
